import React from 'react';
import classnames from 'classnames';

import styles from './InlineToolbar.scss';
import {BoldButton, ItalicButton, BulletsButton} from 'components/controls/RichEditor/Tools';

export default function InlineToolbar(props) {
  const {onToggleInline, onToggleBlock, className, editorState} = props;

  return (
      <div className={classnames(styles.container, className)}>
        <BoldButton onClick={onToggleInline} editorState={editorState} />
        <ItalicButton onClick={onToggleInline} editorState={editorState} />
        <BulletsButton onClick={onToggleBlock} editorState={editorState} />
      </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/controls/RichEditor/InlineToolbar.jsx